// A queued copy outlives the page: switching agents is a hard navigation, and a
// large copy takes minutes. The ids live in localStorage so a reload resumes
// watching instead of letting the copy land unannounced.
const STORAGE_KEY = 'quickchat.pendingCloneJobs';

const read = (): string[] => {
  try {
    const parsed: unknown = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

const write = (ids: string[]): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Storage unavailable: the watcher simply does not survive a reload.
  }
};

export const readPendingCloneJobIds = (): string[] => read();

// Built on the ids already being watched, not on storage alone: a write storage
// refuses must cost the reload, never the watcher of the copy queued before it.
export const rememberPendingCloneJob = (watched: string[], jobId: string): string[] => {
  const next = Array.from(new Set([...watched, ...read(), jobId]));
  write(next);
  return next;
};

export const forgetPendingCloneJob = (watched: string[], jobId: string): string[] => {
  const next = Array.from(new Set([...watched, ...read()])).filter((id) => id !== jobId);
  write(next);
  return next;
};
